import { Injectable, OnInit } from '@angular/core'
import { UserModel } from '../users/user_model'
import { ClientModel } from '../client/client.model'
import { MemberModel } from '../member-client/member.model'
import { CountryModel } from '../masters/country.master/country.model'
import { DeliveredToModel } from '../masters/deliveredTo.master/deliveredTo.model'
import { CurrencyModel } from '../masters/currency.master/currency.model'
import { DeliveryTimeModel } from '../masters/deliveryTime.master/deliveryTime.model'
import { PaymentTypeModel } from '../masters/paymentType.master/paymentType.model'
import { MtcTypeModel } from '../masters/mtcType.master/mtcType.model'
import { ValidityModel } from '../masters/validity.master/validity.model'
import { TransportModeModel } from '../masters/transportMode.master/transportMode.model'
import { ClientService } from '../client/client.service'
import { MemberService } from '../member-client/member.service'
import { CountryService } from '../masters/country.master/country.service'
import { CurrencyService } from '../masters/currency.master/currency.service'
import { DeliveredToService } from '../masters/deliveredTo.master/deliveredTo.service'
import { DeliveryTimeService } from '../masters/deliveryTime.master/deliveryTime.service'
import { MtcTypeService } from '../masters/mtcType.master/mtcType.service'
import { PaymentTypeService } from '../masters/paymentType.master/paymentType.service'
import { TransportModeService } from '../masters/transportMode.master/transportMode.service'
import { ValidityService } from '../masters/validity.master/validity.service'
import { ToastrService } from 'ngx-toastr'
import { QuotationCloseReasonModel } from '../masters/quotationCloseReason.master/quotationCloseReason.model'
import { QuotationCloseReasonService } from '../masters/quotationCloseReason.master/quotationCloseReason.service'
import { MaterialModel } from '../masters/material.master/material.model'
import { MaterialService } from '../masters/material.master/material.service'
import { ProductModel } from '../masters/product.master/product.model'
import { ProductService } from '../masters/product.master/product.service'
import { AuthService } from '../../auth.service'
import { UnitService } from '../masters/unit.master/unit.service'
import { UnitModel } from '../masters/unit.master/unit.model'
import { HsnModel } from '../masters/hsn.master/hsn.model'
import { HsnService } from '../masters/hsn.master/hsn.service'
import { VendorModel } from '../vendor/vendor.model'
import { VendorService } from '../vendor/vendor.service'
import { VendorMemberModel } from '../member-vendor/member-vendor.model'
import { VendorMemberService } from '../member-vendor/member-vendor.service'
import { PartNumberService } from '../masters/partNumber.master/partNumber.service'
import { PartNumberModel } from '../masters/partNumber.master/partNumber.model'

@Injectable({
  providedIn: 'root',
})
export class MasterCommonServices {
  isToastrShown: boolean = false
  isLoading: boolean = false
  isDataLoaded: boolean = false
  usersList: UserModel[] = []
  clientsList: ClientModel[] = []
  materialsList: MaterialModel[] = []
  membersList: MemberModel[] = []
  countriesList: CountryModel[] = []
  deliveredTosList: DeliveredToModel[] = []
  currenciesList: CurrencyModel[] = []
  deliveryTimesList: DeliveryTimeModel[] = []
  paymentsList: PaymentTypeModel[] = []
  productsList: ProductModel[] = []
  mtcTypesList: MtcTypeModel[] = []
  validitiesList: ValidityModel[] = []
  packingTypesList: TransportModeModel[] = []
  quotationCloseReasonsList: QuotationCloseReasonModel[] = []
  unitsList: UnitModel[] = []
  hsnList: HsnModel[] = []
  vendorList: VendorModel[] = []
  vendorMemberList: VendorMemberModel[] = []
  partNumberList: PartNumberModel[] = []

  constructor(
    private toastr: ToastrService,
    private authService: AuthService,
    private clientService: ClientService,
    private materialService: MaterialService,
    private memberService: MemberService,
    private deliveredToService: DeliveredToService,
    private currencyService: CurrencyService,
    private deliveryTimeService: DeliveryTimeService,
    private countryService: CountryService,
    private paymentService: PaymentTypeService,
    private productService: ProductService,
    private mtcTypeService: MtcTypeService,
    private validityService: ValidityService,
    private packingTypeService: TransportModeService,
    private quotationCloseReasonService: QuotationCloseReasonService,
    private unitService: UnitService,
    private hsnService: HsnService,
    private vendorService: VendorService,
    private vendorMemberService: VendorMemberService,
    private partNumberService: PartNumberService,
  ) {}

  showToastrError(message: string) {
    if (!this.isToastrShown) {
      this.isToastrShown = true
      this.toastr.error(message, 'Error').onHidden.subscribe(() => {
        this.isToastrShown = false
      })
    }
  }

  async getAllMasters() {
    this.isDataLoaded = true
    await this.getAllUsers()
    this.getAllClients()
    this.getAllMaterials()
    this.getAllMembers()
    this.getAllDeliveredTos()
    this.getAllCurrencies()
    this.getAllDeliveryTimes()
    this.getAllCountries()
    this.getAllPayments()
    this.getAllProducts()
    this.getAllMtcTypes()
    this.getAllValidities()
    this.getAllPackingTypes()
    this.getAllQuotationCloseReasons()
    this.getAllUnits()
    this.getAllHsn()
    this.getAllVendors()
    this.getAllVendorMembers()
    this.getAllPartNumbers()
  }

  getAllUsers(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.authService.getUsers().subscribe({
        next: (data) => {
          this.usersList = data
          resolve()
        },
        error: (error: any) => {
          this.isLoading = false
          this.showToastrError(error.statusText)
          reject(error)
        },
      })
    })
  }

  getAllClients() {
    this.clientService.getAllClients().subscribe({
      next: (data) => {
        this.clientsList = data.sort((a, b) =>
          a.companyName.localeCompare(b.companyName),
        )
      },
      error: (error: any) => {
        this.isLoading = false
        this.showToastrError(error.statusText)
      },
    })
  }

  getAllHsn() {
    this.hsnService.getAllHsn().subscribe({
      next: (data) => {
        this.hsnList = data
      },
      error: (error: any) => {
        this.isLoading = false
        this.showToastrError(error.statusText)
        return
      },
    })
  }

  getAllMaterials() {
    this.materialService.getAllMaterials().subscribe({
      next: (data) => {
        this.materialsList = data
      },
      error: (error: any) => {
        this.isLoading = false
        this.showToastrError(error.statusText)
        return
      },
    })
  }

  getAllMembers() {
    try {
      this.memberService.getAllMembers().subscribe({
        next: (data) => {
          this.membersList = data
        },
      })
    } catch (error: any) {
      
      

      this.isLoading = false
      this.showToastrError(error.statusText)
      return
    }
  }

  getAllDeliveredTos() {
    this.deliveredToService.getAllDeliveredTos().subscribe({
      next: (data) => {
        this.deliveredTosList = data
      },
      error: (error: any) => {
        this.showToastrError(error.statusText)
        return
      },
    })
  }

  getAllCurrencies() {
    this.currencyService.getAllCurrencies().subscribe({
      next: (data) => {
        this.currenciesList = data
      },
      error: (error: any) => {
        this.showToastrError(error.statusText)
        return
      },
    })
  }

  getAllDeliveryTimes() {
    this.deliveryTimeService.getAllDeliveryTimes().subscribe({
      next: (data) => {
        this.deliveryTimesList = data
      },
      error: (error: any) => {
        this.showToastrError(error.statusText)
        return
      },
    })
  }

  getAllCountries() {
    this.countryService.getAllCountries().subscribe({
      next: (data: any) => {
        this.countriesList = data
      },
      error: (error: any) => {
        this.showToastrError(error.statusText)
        return
      },
    })
  }

  getAllPayments() {
    this.paymentService.getAllPaymentTypes().subscribe({
      next: (data) => {
        this.paymentsList = data
      },
      error: (error: any) => {
        this.showToastrError(error.statusText)
        return
      },
    })
  }

  getAllProducts() {
    this.productService.getAllProducts().subscribe({
      next: (data) => {
        this.productsList = data
      },
      error: (error: any) => {
        this.showToastrError(error.statusText)
        return
      },
    })
  }

  getAllMtcTypes() {
    this.mtcTypeService.getAllMtcTypes().subscribe({
      next: (data) => {
        this.mtcTypesList = data
      },
      error: (error: any) => {
        this.showToastrError(error.statusText)
        return
      },
    })
  }

  getAllValidities() {
    this.validityService.getAllValidities().subscribe({
      next: (data) => {
        this.validitiesList = data
      },
      error: (error: any) => {
        this.showToastrError(error.statusText)
        return
      },
    })
  }

  getAllPackingTypes() {
    this.packingTypeService.getAllTransportModes().subscribe({
      next: (data: any) => {
        this.packingTypesList = data
      },
      error: (error: any) => {
        this.showToastrError(error.statusText)
        return
      },
    })
  }

  getAllQuotationCloseReasons() {
    this.quotationCloseReasonService.getAllQuotationCloseReasons().subscribe({
      next: (data: any) => {
        

        this.quotationCloseReasonsList = data
      },
      error: (error: any) => {
        this.showToastrError(error.statusText)
        return
      },
    })
  }

  getAllUnits() {
    this.unitService.getAllUnits().subscribe({
      next: (data) => {
        this.unitsList = data
      },
      error: (error: any) => {
        this.isLoading = false
        this.showToastrError(error.statusText)
        return
      },
    })
  }

  getAllVendors() {
    this.vendorService.getAllVendors().subscribe({
      next: (data) => {
        this.vendorList = data.sort((a, b) =>
          a.vendorName.localeCompare(b.vendorName),
        )
      },
      error: (error: any) => {
        this.isLoading = false
        this.showToastrError(error.statusText)
      },
    })
  }

  getAllVendorMembers() {
    try {
      this.vendorMemberService.getAllVendorMembers().subscribe({
        next: (data) => {
          this.vendorMemberList = data
        },
      })
    } catch (error: any) {
      
      

      this.isLoading = false
      this.showToastrError(error.statusText)
      return
    }
  }

  getAllPartNumbers() {
    this.partNumberService.getAllPartNumbers().subscribe({
      next: (data: any) => {
        this.partNumberList = data
      },
      error: (error: any) => {
        this.showToastrError(error.statusText)
        return
      },
    })
  }

  getCurrencyName(currencyId: number): string {
    const currency = this.currenciesList.find((c) => c.id === currencyId)
    return currency != undefined ? currency.currencyName : '-'
  }

  getPackingTypeName(packingTypeId: number): string {
    const packingType = this.packingTypesList.find(
      (p) => p.id === packingTypeId,
    )
    return packingType != undefined ? packingType.transportMode : '-'
  }

  getDeliveryTimeName(deliveryTimeId: number): string {
    const deliveryTime = this.deliveryTimesList.find(
      (d) => d.id === deliveryTimeId,
    )

    return deliveryTime != undefined ? deliveryTime.deliveryTime : '-'
  }

  getDeliveredToName(deliveredToId: number): string {
    const deliveredTo = this.deliveredTosList.find(
      (d) => d.id === deliveredToId,
    )
    return deliveredTo != undefined ? deliveredTo.deliveryName : '-'
  }

  getPaymentTypeName(paymentTypeId: number): string {
    const paymentType = this.paymentsList.find((p) => p.id === paymentTypeId)
    return paymentType != undefined ? paymentType.paymentType : '-'
  }

  getMtcTypeName(mtcTypeId: number): string {
    const mtcType = this.mtcTypesList.find((m) => m.id === mtcTypeId)
    return mtcType != undefined ? mtcType.mtcType : '-'
  }

  getValidityName(validityId: number): string {
    const validity = this.validitiesList.find((v) => v.id === validityId)
    return validity != undefined ? validity.validity : '-'
  }

  getCountryName(countryId: number): string {
    const country = this.countriesList.find((c) => c.id === countryId)
    return country != undefined ? country.countryName : '-'
  }

  getHsnName(hsnId: number): string {
    const hsn = this.hsnList.find((h) => h.id === hsnId)
    return hsn != undefined ? hsn.hsnName : '-'
  }

  getAssignedToName(assignedToId: number): UserModel | undefined {
    const index = this.usersList.findIndex((user) => user.id == assignedToId)
    if (index != -1) {
      return this.usersList[index]
    }
    return undefined
  }

  getClientName(clientId: number): ClientModel | undefined {
    const index = this.clientsList.findIndex((client) => client.id == clientId)
    if (index != -1) {
      return this.clientsList[index]
    }
    return undefined
  }

  getMemberName(memberId: number): MemberModel | undefined {
    const index = this.membersList.findIndex((member) => member.id == memberId)
    if (index != -1) {
      return this.membersList[index]
    }
    return undefined
  }

  getUnitName(unitId: number): UnitModel | undefined {
    const index = this.unitsList.findIndex((unit) => unit.id == unitId)
    if(index != -1) {
      return this.unitsList[index]
    }
    return undefined
  }

  getVendorName(vendorId: number): VendorModel | undefined {
    const index = this.vendorList.findIndex((vendor) => vendor.id == vendorId)
    if (index != -1) {
      return this.vendorList[index]
    }
    return undefined
  }

  getVendorMemberName(vendorMemberId: number): VendorMemberModel | undefined {
    const index = this.vendorMemberList.findIndex(
      (vendorMember) => vendorMember.id == vendorMemberId,
    )
    if (index != -1) {
      return this.vendorMemberList[index]
    }
    return undefined
  }

  getPartNumberName(partNumberId: number): PartNumberModel | undefined {

    const index = this.partNumberList.findIndex((partNumber) => partNumber.id == partNumberId)
    
    
    
    if (index != -1) {
      return this.partNumberList[index]
    }
    return undefined
  }
}
